import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const scoreSttingsRouter: RouteConfig = {
  path: "/scoreSettings",
  component: Layout,
  meta: {
    title: "成绩设置",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "scanPermission",
      name:'scanPermission',
      component: () =>
        import(
          /* webpackChunkName: "score-settings" */ "@/views/score-settings/index.vue"
        ),
      meta: {
        title: "成绩权限设置",
        icon: "setting",
        permission: "Pages.Settings"
      }
    },
  ]
};

export default scoreSttingsRouter;
